import ReportTab from "../storageRoles/ReportTab";
import { useFirmReportData } from "../../../../Hooks/dealerRoles/useFirmReportData";

export default function DealerRolesReportTab({ firm }) {
  return <ReportTab firm={firm} useReportHook={useFirmReportData} />;
}
